import React, {
  createContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button } from "antd";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";

const PANEL_PADDING = 32;

export const ZoomContext = createContext({ zoom: false, width: 0 });

export default function ZoomPanel({ children }) {
  const [zoom, setZoom] = useState(false);
  const [width, setWidth] = useState(0);
  const panelRef = useRef(null);

  useEffect(() => {
    if (!zoom) return undefined;
    const onKeyDown = (e) => e.key === "Escape" && setZoom(false);
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [zoom]);

  useEffect(() => {
    const el = panelRef.current;
    if (!zoom || !el) {
      setWidth(0);
      return undefined;
    }
    const measure = () => setWidth(el.clientWidth - PANEL_PADDING);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [zoom]);

  const value = useMemo(() => ({ zoom, width }), [zoom, width]);

  return (
    <div
      ref={panelRef}
      className={zoom ? "tab-zoom-wrap tab-zoom-active" : "tab-zoom-wrap"}
    >
      <Button
        size="small"
        title={zoom ? "Thu nhỏ (Esc)" : "Phóng to"}
        className="tab-zoom-btn"
        icon={zoom ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        onClick={() => setZoom(!zoom)}
      />
      <ZoomContext.Provider value={value}>{children}</ZoomContext.Provider>
    </div>
  );
}
